import React from 'react';
import { Package, Zap, HeartHandshake, Shield } from 'lucide-react';

export const Purpose = () => {
  return (
    <section id="proposito" className="py-20 bg-gradient-to-br from-gray-800 via-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`
      }}></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold uppercase tracking-wider">
            Nosso Propósito
          </span>
          <h2 className="mt-6 text-4xl sm:text-5xl font-bold">
            Garantir que empresas não parem
          </h2>
          <p className="mt-4 text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            A SSA nasce da convicção de que tudo que importa não pode parar. O mundo não se move por acaso, 
            ele se move porque existem estruturas invisíveis sustentando cada jornada.
          </p>
        </div>

        {/* Mission Statement */}
        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 md:p-12 mb-12 border border-white/20">
          <p className="md:text-xl !text-lg text-gray-200">
            Caminhões e ônibus não transportam apenas cargas. Eles carregam vidas, alimentos, medicamentos, trabalho, progresso. Quando um deles para, algo maior do que uma máquina é afetado.
          </p>
          <p className="mt-6 text-lg md:text-xl leading-relaxed text-gray-200">
            Por isso, a SSA não existe para vender peças. <span className="font-bold text-white">Existe para sustentar operações, preservar rotas e garantir continuidade.</span>
          </p>
        </div>

        {/* Core Values */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105">
            <div className="flex items-center justify-center w-14 h-14 bg-red-600 rounded-lg mb-4">
              <Shield size={28} />
            </div>
            <h3 className="text-xl font-bold mb-2">Responsabilidade</h3>
            <p className="text-gray-300">Responsabilidade vem antes do lucro</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105">
            <div className="flex items-center justify-center w-14 h-14 bg-red-600 rounded-lg mb-4">
              <Package size={28} />
            </div>
            <h3 className="text-xl font-bold mb-2">Excelência</h3>
            <p className="text-gray-300">Excelência técnica é compromisso moral</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105">
            <div className="flex items-center justify-center w-14 h-14 bg-red-600 rounded-lg mb-4">
              <Zap size={28} />
            </div>
            <h3 className="text-xl font-bold mb-2">Antecipação</h3>
            <p className="text-gray-300">Manutenção é cuidado antecipado</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105">
            <div className="flex items-center justify-center w-14 h-14 bg-red-600 rounded-lg mb-4">
              <HeartHandshake size={28} />
            </div>
            <h3 className="text-xl font-bold mb-2">Continuidade</h3>
            <p className="text-gray-300">Sustentamos quem sustenta o país</p>
          </div>
        </div>

        {/* Closing Statement */}
        <div className="mt-16 text-center">
          <blockquote className="text-2xl md:text-3xl font-bold italic">
            "Onde outros veem metal, nós enxergamos propósito em continuidade."
          </blockquote>
          <p className="mt-4 text-lg text-gray-300">
            A SSA atua como instrumento de sustentação. Agora a SSA não só vende. Ela significa.
          </p>
        </div>
      </div>
    </section>);

};